<template>
	<div class="container-right">
		<div class="conCompany">
			<div class="formCompany">
				<div class="right-SecondTitle">
					<div class="h4">添加企业著作权人</div>
					<a @click="back"> 返回上一级 </a>
					<div class="line"></div>
				</div>
				<div class="MainStepsForm">
					<div class="formWrap fl">
						<el-form ref="form" :model="form" :rules="rules" label-width="180px" v-loading="isLoading">
							<!-- <el-form-item label="法人姓名" prop="name">
							<el-input v-model="form.userName"></el-input>
						</el-form-item> -->
						<el-form-item label="企业名称" prop="companyName">
							<el-input v-model="form.companyName" placeholder="请输入企业名称" :disabled="isDisabled"></el-input>
							<div class="blockReminder blockReminder2" v-if="isDisabled">
								<div class="description" slot="description">请通过上传证件进行识别</div>
							</div>
						</el-form-item>
						<el-form-item label="证件类型" prop="identityType">
							<el-select v-model="identityName" @change="selectChanged">
							
								<el-option v-for="item in company" :key="item.id" :lable="item.id" :value="item.identityName"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号" prop="uniqueCode" >
                            <el-input v-model="form.uniqueCode" placeholder="请输入证件号" 
                            @input="
                            form.uniqueCode = form.uniqueCode.replace(/[\W]/g,'')" :disabled="isDisabled"></el-input>
							<div class="blockReminder blockReminder2" v-if="isDisabled">
								<div class="description" slot="description">请通过上传证件进行识别</div>
							</div>
                        </el-form-item>
						<el-form-item label="联系方式" prop="contactPhone">
                            <el-input v-model="form.contactPhone" placeholder="请输入联系方式" @input="
                            form.contactPhone = form.contactPhone.replace(/[^\d-]/g,'')"></el-input>
                        </el-form-item>
                        <el-form-item label="证件是否长期有效" prop="longValid">
                            <el-radio-group v-model="form.longValid" @change="changeLongValid" :disabled="isDisabled">
								<el-radio label="1">是</el-radio>
								<el-radio label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="证件有效时间" prop="startDate">
							<el-col :span="11">
								<el-date-picker type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="timestamp" v-model="form.startDate"
								 style="width: 100%;" :disabled="isDisabled"></el-date-picker>
							</el-col>
							<el-col :span="2" v-if="this.form.longValid == '2'" style="text-align: center;">-</el-col>
							<el-col :span="11" v-if="this.form.longValid == '2'">
								<el-date-picker type="date" placeholder="截止日期" format="yyyy-MM-dd" value-format="timestamp" v-model="form.expireDate"
								 style="width: 100%;" :disabled="isDisabled"></el-date-picker>
							</el-col>
							<div class="blockReminder blockReminder2" v-if="isDisabled">
								<div class="description" slot="description">请通过上传证件进行识别</div>
							</div>
						</el-form-item>
						<el-form-item label="国家省市" prop="province" :rules="[{ required: true, validator: valiCity, trigger: 'blur' }]">
							<china-area-data @change="cityChange" :isAddObligee='true'></china-area-data>
						</el-form-item>
						<!-- <el-form-item label="详细地址" prop="address">
							<el-input v-model="form.address"></el-input>
						</el-form-item> -->
						<el-form-item label="上传证件照片" prop="additionalProp1" :rules="[{ required: true, validator: valiIcon, trigger: 'blur' }]" >
							<div class="uploadBusinessLicense" >
								<el-upload class="Uploader fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess"
								 :before-upload="uploadBefore" v-loading="loading1">
									<img v-if="form.identityPicture.additionalProp1" :src="form.identityPicture.additionalProp1" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<div class="clear"></div>
							</div>

							<i class="iconfont iconRotate" @click="rotateImage(90)">&#xe69e;</i>
							<div class="clear"></div>

							<div class="blockReminder">
								<div class="h3">上传证件要求：</div>
								<div class="description" slot="description">
									1、上传的证件内容必须清晰可见<br>
									2、作者名称和证件号码与提交的证件信息一致<br>
									3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨<br>
									4、须小于5MB，且为JPG/PNG格式，尺寸过小不宜上传(推荐800*600以上)<br>
									5、证件在有效期之内
								</div>
							</div>
							<div class="exampleWrap">
								上传证件示例：
								<div class="exampleimg"></div>
							</div>
						</el-form-item>
						<el-form-item label="上传电子印章" prop="signature" :rules="[{ required: true, validator: valiIcon2, trigger: 'blur' }]">
							<div class="uploadBusinessLicense" >
								<!-- <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess3"
								 :before-upload="uploadBefore3" v-loading="loading3">
									<img v-if="form.supportingMaterial.signature" :src="form.supportingMaterial.signature" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload> -->
	<!-- 裁剪图片基本使用 -->
    <upload-cropper
      :width="300"
      :height="300"
	  :signature-type="'yinzhang'"
	  @confirm-crop="handleUploadImage"
	  :signature-url="form.supportingMaterial.signature"
    />
								<el-upload class="originalUpload"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess3"
									:before-upload="uploadBefore3">
									<el-button type="mini">原图上传</el-button>
								</el-upload>

								<div class="clear"></div>
							</div>
							<div class="blockReminder">
								<div class="description" slot="description">
									1、推荐尺寸：150*150 的等比例<span>透底</span>PNG图片<br>
									2、您的电子签名与印章图案仅用于版权登记材料生成，不用于任何其他用途，系统会对其安全储存。请妥善保管好您的账号，由账号泄漏导致的影响与损失与本平台无关。
								</div>
							</div>
						</el-form-item>
						<!-- <el-form-item label="上传证明材料" prop="additionalProp2">
							<div class="uploadBusinessLicense" >
								<el-upload class="Uploader fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess2"
								 :before-upload="uploadBefore2" v-loading="loading2">
									<img v-if="form.identityPicture.additionalProp2" :src="form.identityPicture.additionalProp2" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<div class="clear"></div>
							</div> -->
							<!-- <div class="uploadBusinessLicense" >
								<el-upload class="Uploader2 fl" :action="uploadUrl"  :headers="uploadHeaders" :on-success="uploadSuccess2"
								 :before-upload="uploadBefore2">
									<div class="commonUploadInner">
										<i class="iconfont iconUpload">&#xe647;</i>
										<div class="el-upload__text">
											<div>将文件拖到此处，或<em>点击上传</em></div>
										</div>
									</div>
								</el-upload>
								<div class="clear"></div>
							</div> -->
							<!-- <div class="blockReminder">
								<div class="description" slot="description">
									<a href="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-wt.docx" download="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/agent-contract-wt.docx">委托代理合同附件</a>点击下载后，加盖单位公章，法定代表人签字后拍照上传。
								</div>
							</div>
						</el-form-item> -->

						<el-form-item class="submitRow">
							<el-button type="primary" @click="onSubmit('form')">确认提交</el-button>
						</el-form-item>
						</el-form>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import UploadCropper from '@/components/form/UploadCropper.vue'
	import {
		createObligee,ocrBoth2
	} from '@/api/ObligeeService'
	import ChinaAreaData from '@/components/ChinaAreaData'
	import { queryObligeeList } from '@/api/ObligeeService'
	export default {
		name: 'AddCompany',
		components: { ChinaAreaData,UploadCropper },
		data() {
			return {
				isLoading: false,
				form: {
					userName: '',
					obligeeType: '2',
					identityPicture: {
						additionalProp1: '',
						additionalProp2: '',
					},
					companyName: null,
					uniqueCode: '',
					contactPhone: '',
					startDate: null,
					expireDate: null,
					address: '',
					identityType: '2',
					longValid: "2",
					province: '',
					city: '',
					supportingMaterial: {signature:''},
					inputType: '00',	//自动识别 inputType为00，手工输入为01
				},
				uploadUrl: `${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), // 添加随机数
				uploadHeaders: {
					'Authorization': this.$store.getters.token,
					'Product-Mode': "READ",
					'Terminal-Code': "IPCHAIN2" + this.$store.getters.terminalCode,
					'Terminal-Type': "WEB",
					'Merchant-Id': "2"
				},
				rotation: 0,
      			originalFile: null,
				rules: {
					// userName: [{
					// 		required: true,
					// 		message: '请输入法人姓名',
					// 		trigger: 'blur'
					// 	},
					// 	{
					// 		min: 2,
					// 		max: 50,
					// 		message: '长度在 2 到 50 个字符',
					// 		trigger: 'blur'
					// 	}
					// ],
					// icon: [{
					// 	required: true,validator: this.valiIcon, trigger: 'change'
					// }],
					companyName: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					identityType: [{
						required: true,
						message: '请选择证件类型',
						trigger: 'blur'
					}],
					uniqueCode: [{
						required: true,
						message: '请输入证件号',
						trigger: 'blur'
					}],
					contactPhone: [
						{ 
							required: true, 
							message: '请输入联系方式', 
							trigger: 'blur' 
						},
						{ 
							validator: (rule, value, callback) => {
								// 手机号：11位数字，以1开头
								const mobileRegex = /^1\d{10}$/;
								// 座机号：区号-号码，如 010-88888888 或 0755-88888888
								const phoneRegex = /^0\d{2,3}-\d{7,8}$/;
								// 座机号无横线格式
								const phoneRegex2 = /^0\d{2,3}\d{7,8}$/;
								
								if (mobileRegex.test(value) || phoneRegex.test(value) || phoneRegex2.test(value)) {
									callback();
								} else {
									callback(new Error('请输入正确的手机号或座机号（如：010-88888888）'));
								}
							}, 
							trigger: 'blur' 
						}
					],
					longValid: [{
						required: true,
					}],

					startDate: [{
						// type: 'date',
						required: true,
						message: '请选择开始日期',
						trigger: 'change'
					}],
					expireDate: [{
						// type: 'date',
						required: true,
						message: '请选择截止日期',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入公司地址',
						trigger: 'blur'
					}]
				},
				imageUrl: '',

				company: [
					{
						"id": 2,
						"orders": 1,
						"parentId": 2,
						"identityName": "营业执照"
					},
					{
						"id": 3,
						"orders": 2,
						"parentId": 2,
						"identityName": "企业法人营业执照"
					},
					{
						"id": 4,
						"orders": 3,
						"parentId": 2,
						"identityName": "组织机构代码证书"
					},
					{
						"id": 5,
						"orders": 4,
						"parentId": 2,
						"identityName": "事业单位法人证书"
					},
					{
						"id": 6,
						"orders": 5,
						"parentId": 2,
						"identityName": "社团法人证书"
					},
					{
						"id": 12,
						"orders": 6,
						"parentId": 2,
						"identityName": "社会统一信用代码证"
					},
					{
						"id": 7,
						"orders": 7,
						"parentId": 2,
						"identityName": "其他有效证件"
					}
				],
				identityName: '营业执照',
				isDisabled: true,

				loading1: false,
				loading2: false,
				loading3: false,
			}
		},
		methods: {
			back() {
				this.$emit('set-tab-idx', 'tab1')
			},
			valiIcon(rule, value, callback){
					if (!this.form.identityPicture.additionalProp1) {
					  callback(new Error('请上传证件照片'));
					  return; 
					}
					callback();
			},
			valiIcon2(rule, value, callback){
					if (!this.form.supportingMaterial.signature) {
					  callback(new Error('上传电子印章'));
					  return; 
					}
					callback();
			},
			valiCity(rule, value, callback){ 
					if (!this.form.province) {
					  callback(new Error('请选择省份'));
					  return;
					}
					if (!this.form.city) {
					  callback(new Error('请选择城市'));
					  return;
					}
					// if (!this.form.area) {
					//   callback(new Error('请选择区县'));
					//   return;
					// }
					callback();
			},
			cityChange(data) {
				// console.log(data);
				if(data.laber == 'province'){
					this.form.province = data.value;
					this.form.city = '';
				}else if(data.laber == 'city'){
					this.form.city = data.value;
				}
				this.$refs.form.validateField('province');
      			this.$refs.form.validateField('city');
				// this.form.area = data.selectData.area.name;
			},
			onSubmit(formName) {
				this.isLoading = true;
				this.$refs[formName].validate((valid) => {
				          if (valid) {
				            this.form.startDate = this.form.startDate / 1000;
				            this.form.expireDate = this.form.expireDate / 1000;
							this.startDateText = this.form.startDate * 1000;
							this.expireDateText = this.form.expireDate * 1000;
				            let that = this;
				            createObligee(this.form).then((data) => {
								this.$message.success('添加成功!');
				            	that.$emit('set-tab-idx', 'tab1');
				            	that.$parent.fetchData();
								this.bus.$emit("refreshObligee");  // 更新vue事件总线中vuex的著作权人列表
								this.isLoading = false;
				            }).catch(e => {
				            	this.$message.error('服务请求失败，请稍后重试!');
								this.isLoading = false;
				            });
				          } else {
				            console.log('error submit!!');
							this.isLoading = false;
				            return false;
				          }
				});
			},
			uploadSuccess(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.identityPicture.additionalProp1 = res.downloadUrl;
				this.$refs.form.validateField('identityPicture.additionalProp1');
				this.loading1 = false;
				// 根据上传的身份证直接获取用户身份证信息
				if(this.form.identityType == '2'){	// 只有营业执照需要识别
					// 创建Loading实例
					const loadingInstance = this.$loading({
						lock: true,
						text: '正在识别营业执照信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					ocrBoth2({imageUrl:res.downloadUrl}).then((data) => {
						// console.log('根据上传的照片自动获取信息：',data);
						loadingInstance.close(); // 关闭loading
						this.form.companyName = data.data.enterpriseName;
						this.form.uniqueCode= data.data.unifiedSocialCreditCode;
						// 优先等级：有营业期限 > 成立日期
						if(data.data.businessTermStartDate){
							this.form.startDate = data.data.businessTermStartDate * 1000;
							this.form.expireDate = data.data.businessTermEndDate?data.data.businessTermEndDate * 1000:'';
						}else if(data.data.establishmentDate){
							this.form.startDate = data.data.establishmentDate * 1000;
						}
						
						// console.log(this.form.expireDate)
						if(this.form.expireDate ==''){
							this.form.longValid= '1'
						}else{
							this.form.longValid= '2'
						}
						// this.form.address = data.data.address;
						// this.form.province = data.data.address;
						// this.form.city = data.data.address;
						
					}).catch(e => {
						loadingInstance.close(); // 关闭loading
						this.$message.error('获取证件信息失败！请手工录入著作权人信息。');
						this.isDisabled = false;
						this.form.inputType = '01';
					});
				}
			},
			uploadBefore(file) {
				console.log(file);
				this.originalFile = file
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading1 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
					this.loading1 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading1 = false;
				}
				return isImage && isLt2M;
			},
			async rotateImage(degrees) {
				if(!this.form.identityPicture.additionalProp1){
					this.$message.error('请先上传照片!');
					return false
				}
				this.loading1 = true;
				this.rotation += degrees;
				if (!this.originalFile) return
				try {
					// 创建旋转后的图片文件
					const rotatedFile = await this.rotateAndCreateFile(this.originalFile, this.rotation)
					// 重新上传旋转后的图片
					const formData = new FormData()
					formData.append('file', rotatedFile)
					
					// 重新上传处理
					// this.$refs.uploader1.data = formData;
					// this.$refs.uploader1.submit()

					// 使用 axios 上传
					// await axios({
					// 	url: this.uploadUrl,
					// 	headers: this.uploadHeaders,
					// 	method: 'post',
					// 	data: formData
					// }).then((res) => {
					// 	console.log(res);
					// 	if (res.data.code == 200) {

					// 	}
					// })

					// 使用 Fetch API 上传
					return fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), {
						method: "POST",
						body: formData,
						headers: this.uploadHeaders,
					}).then(res => res.json()).then(res => {
						if(!res.downloadUrl){
							this.$message.error('翻转失败！');
							return false
						}
						this.form.identityPicture.additionalProp1 = res.downloadUrl;
						this.$refs.form.validateField('identityPicture.additionalProp1');
						this.loading1 = false;
						this.originalFile = rotatedFile;
						this.rotation = 0;
					});

				} catch (error) {
					this.$message.error('上传失败:' + error.message)
				}
			},
			rotateAndCreateFile(file, rotation) {
				return new Promise((resolve) => {
					if (rotation % 360 === 0) {
					// 不需要旋转，直接返回原文件
					resolve(file)
					return
					}
					
					const reader = new FileReader()
					reader.onload = (e) => {
					const img = new Image()
					img.onload = () => {
						const canvas = document.createElement('canvas')
						const ctx = canvas.getContext('2d')
						
						// 调整画布大小以适应旋转后的图片
						if (rotation % 180 !== 0) {
						canvas.width = img.height
						canvas.height = img.width
						} else {
						canvas.width = img.width
						canvas.height = img.height
						}
						
						// 旋转并绘制图片
						ctx.translate(canvas.width / 2, canvas.height / 2)
						ctx.rotate(rotation * Math.PI / 180)
						ctx.drawImage(img, -img.width / 2, -img.height / 2)
						
						// 转换为Blob对象
						canvas.toBlob((blob) => {
						const rotatedFile = new File([blob], file.name, {
							type: file.type,
							lastModified: Date.now()
						})
						resolve(rotatedFile)
						}, file.type)
					}
					img.src = e.target.result
					}
					reader.readAsDataURL(file)
				})
			},
			uploadSuccess2(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.identityPicture.additionalProp2 = res.downloadUrl;
				this.$refs.form.validateField('identityPicture.additionalProp2');
				this.loading2 = false;
			},
			uploadBefore2(file) {
				console.log(file);
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading2 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
					this.loading2 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading2 = false;
				}
				return isImage && isLt2M;
			},
			uploadSuccess3(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.supportingMaterial.signature = res.downloadUrl;
				this.$refs.form.validateField('supportingMaterial.signature');
				this.loading3 = false;
			},
			uploadBefore3(file) {
				console.log(file);
				// 电子印章只能是png格式
				const isImage = file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading3 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 PNG 格式!');
					this.loading3 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading3 = false;
				}
				return isImage && isLt2M;
			},
	// 调用组件函数
	handleUploadImage(data) {
		//   console.log('开始上传图片:', file)
		// 创建 FormData
		const formData = new FormData()
		formData.append('file', data.file)
		// 使用 Fetch API 发送请求
		fetch(this.uploadUrl, {
			method: 'POST',
			headers: this.uploadHeaders,
			body: formData,
		}).then(res => res.json()).then(res => {
			// console.log('上传成功，返回数据:', res)
			// this.$message.success('上传成功！')
			this.form.supportingMaterial.signature = res.downloadUrl;
			this.$refs.form.validateField('supportingMaterial.signature');
			this.loading3 = false;
		}).catch(error => {
			this.$message.error('上传失败：' + error.message)
			throw error
		})
    },

			// uploadSuccess2(res, file) {
			// 	this.form.supportingMaterial.push(res);
			// },
			// uploadBefore2(file) {
			// 	// console.log(file);
			// 	// const isDocx = file.type === 'docx';
			// 	// // const isLt2M = file.size / 1024 / 1024 < 5;
			// 	// if (!isDocx) {
			// 	// 	this.$message.error('上传文件只能是docx格式');
			// 	// }
			// 	// return isDocx;
			// },

			// 修改证件类型下拉
			selectChanged(value){
				console.log(value);
				if(value == "营业执照"){
					this.form.identityType = '2'
					this.isDisabled = true
				}else if(value == "企业法人营业执照"){
					this.form.identityType = '3'
					this.isDisabled = false
				}else if(value == "组织机构代码证书"){
					this.form.identityType = '4'
					this.isDisabled = false
				}else if(value == "事业单位法人证书"){
					this.form.identityType = '5'
					this.isDisabled = false
				}else if(value == "社团法人证书"){
					this.form.identityType = '6'
					this.isDisabled = false
				}else if(value == "社会统一信用代码证"){
					this.form.identityType = '12'
					this.isDisabled = false
				}else if(value == "其他有效证件"){
					this.form.identityType = '7'
					this.isDisabled = false
				}
			},
			// 改变证件是否有效期单选
			changeLongValid(value){
				// console.log(value);
				this.form.longValid = value
			},
		}
	}
</script>

<style lang='scss' scoped>
	@import "../../../../assets/css/inputForm.scss";
	@import "../../../../assets/css/mine.scss";


	.formCompany {
		.blockReminder {
			background: rgba(255, 231, 186, 0.2);
			border: 1px solid #FFD591;
			padding: 16px;
			// margin-left: -220px;
			width: 480px;
			margin-top: 8px;
			line-height: 1.5;

			.h3 {
				font-size: 16px;
				font-weight: 600;
				color: rgba(0, 18, 22, 0.65);
				margin-bottom: 8px;
			}

			.description {
				font-size: 12px;
				font-weight: 400;
				color: rgba(0, 18, 22, 0.5);
				a{
					color: #007DFF;
					border-bottom: 1px solid #007DFF;
				}
				span{color: #007DFF;}
			}
		}

		.blockReminder2{
			width: 200px;
			position: absolute;
			right: -220px;
			margin-top: 0;
			top: 0;
			padding: 0 16px;
			line-height: 38px;
			border-radius: 4px;
		}

		.exampleimg {
			background: url('https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/exampleCompany.png') no-repeat;
			background-size: auto 98px;
			width: 325px;
			height: 98px;
		}
	}

	.conCompany {
		.MainStepsForm {
			.formWrap {
				width: 568px;
			}
		}

		.uploadBusinessLicense {
			.Uploader,.Uploader2 {
				width: 132px;
				height: 180px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				position: relative;
			}
			.Uploader2{
				height: 132px;
			}

			.Uploader:first-child {
				margin-right: 16px;
			}

			.Uploader:hover {
				border-color: #007DFF;
			}
			
			.Uploader img{
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				text-align: center;
				line-height: 178px;
			}
			.Uploader2 .avatar-uploader-icon{
				line-height: 130px;
			}

			.avatar {
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				display: block;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}
		}

		.exampleWrap {
			margin-top: 8px;
		}

		/deep/.el-col-8 {
			padding-right: 8px;
		}

		/deep/.el-col-8:last-child {
			padding-right: 0px;
		}

		/deep/.el-upload {
			display: block;
		}
	}

	.resultCompany {
		.resultwrap {
			margin-bottom: 16px;
			padding: 24px 24px 24px 80px;
			box-sizing: border-box;
			background: #F5FDFD;
			border-radius: 2px;
			border: 1px solid #D3DCE6;
			position: relative;
			font-size: 16px;
			font-weight: 600;
			color: rgba(0, 18, 22, 0.65);
			line-height: 24px;

			.icon {
				color: #0A4FD1;
				font-size: 40px;
				position: absolute;
				top: 24px;
				left: 24px;
			}
		}

		.BusinessLicensewrap {
			.BusinessLicense {
				width: 132px;
				height: 180px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				overflow: hidden;
			}

			.IDcard:first-child {
				margin-right: 16px;
			}
		}

	}

	.iconRotate{
		display: block;
		width: 180px;
		float: left;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}
	.iconRotate:nth-child(2){
		margin-right: 16px;
	}
	
	.uploadBusinessLicense{position: relative;height: 132px;}
	.originalUpload{position: absolute;left: 150px;bottom: 0;}
	.originalUpload button{display: block;margin: 0;width: 100px;}

</style>
